/**
 * WareBee Digital Twin - Process KPIs
 * Metrics related to specific warehouse processes
 */

/**
 * Process KPIs
 */
export const processKpis /*: WarehouseKPI[] */ = [
  // Only keep process KPIs that do not fit into receiving, picking, putaway, packing, shipping, or returns
];

export default processKpis;
